import React from 'react';
import { ProductsData } from '../data/products-data';
import { Link, useParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';  // Import AnimatePresence from framer-motion
import ProductItem from '../components/ProductItem';

const Urunler = () => {
  const { id1 } = useParams();

  const category = ProductsData.find(cat => cat.categoryUrl === id1);
  console.log(category)
  // Animation variants for staggered effect
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3, // Stagger each child by 0.2 seconds on enter
      },
    },

  };



  return (
    <div className='min-h-screen  bg-red pb-20 pt-10'>
      {category ? (
        <div className='grid grid-cols-10'>

          {/* <div className='col-start-2 col-span-8  flex flex-col text-turkuaz-blue'>
            <div className='flex text-xs'>
              <Link to={'/'} className='mb-5'>ÜRÜNLER / </Link>
              <Link to={`/urunler/${category.categoryUrl}`} className='uppercase '>{` ${category.categoryName}`}</Link>
            </div>
            <h1 className='text-4xl font-medium text-black mb-10'>{category.categoryName}</h1>

            <div className=' bg-red-600'>

            </div>

          </div> */}


            {/* Animate the grid container */}
            <motion.div
              className='col-start-2 col-span-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8'
              variants={containerVariants}
              initial="hidden"
              whileInView="show"
              exit="exit"  


            >
    
              <AnimatePresence>
                {category.products.map((product, index) => (

                <ProductItem index={index} category={category} product={product} type="product" />

                ))}
              </AnimatePresence>



              
            </motion.div>
      
        </div>
      ) : (
        <p className='text-white'>No category found.</p>
      )}
    </div>
  );
}

export default Urunler;
